import React from "react"

const HighlightText = ({ text }) => {
  return (
    <span className="text-gradient font-display font-bold">
      {text}
    </span>
  )
}

export default HighlightText
